import i18next from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

// cat. app
import Option from "./_define/Option";

const i18nConfiguration = (callback) => {
    //const language = i18next.language || window.localStorage.i18nextLng || 'ko';
    const language = 'ko';
    let isInitialized = i18next.isInitialized;

    let localePath = "locales";
    if(window && window.INTO_SETTINGS && window.INTO_SETTINGS.L10N){
        localePath = window.INTO_SETTINGS.L10N;
    }

    let i18nextOptions = {
        resources: isInitialized ? i18next.store.data : null,

        /* Default Language */
        lng: language,

        /* 현재 언어만 Load */
        load: 'languageOnly',

        /* Init 시 추가 언어를 미리 로드 */
        // preload : false,

        /* 사용할 Namespace List */
        ns: ['evaluation'],

        /* Default Namespace */
        defaultNS: 'evaluation',

        /* 사용자 언어를 사용할 수 없는 경우 사용할 언어. */
        fallbackLng: false,

        /* Debug */
        debug: false,

        /* 다국어에 동적 값을 통합 */
        interpolation: {
            escapeValue: false, // XSS 주입을 피하기 위해 값으로 전달 된 이스케이프 [Default : true]
        },

        /* 비동기 로드를 위한 BackEnd Load Path 설정 */
        backend: {
            loadPath: Option.CONTEXT_PATH + localePath + '/{{lng}}/{{ns}}.json',
            crossDomain: true,
            withCredentials: false,
        },

        /* 일부 리소스는 초기화시 설정하고 다른 리소스는 백엔드 커넥터를 사용하여 로드 */
        partialBundledLanguages: false,

        react: {
            wait: true,
            useSuspense: false,
            withRef: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }
    }

    i18next
        // load translation using xhr -> see /public/locales
        // learn more: https://github.com/i18next/i18next-xhr-backend
        .use(Backend)
        .use(LanguageDetector)
        // pass the i18n instance to react-i18next.
        .use(initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init(i18nextOptions, (err, t) => {
            callback && callback();
        });
}

export default i18nConfiguration;